import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { SIDE_NAV_OPENED_WIDTH, SIDE_NAV_CLOSED_WIDTH, TOUCH_HEIGHT } from '../SideNavigation.constants.js';

var _templateObject, _templateObject2;
var Aside = styled.aside(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 100%;\n  width: ", ";\n  min-width: ", ";\n  position: relative;\n\n  ", "\n"])), function (_ref) {
  var $isOpen = _ref.$isOpen;
  return $isOpen ? SIDE_NAV_OPENED_WIDTH : SIDE_NAV_CLOSED_WIDTH;
}, function (_ref2) {
  var $isOpen = _ref2.$isOpen;
  return $isOpen ? SIDE_NAV_OPENED_WIDTH : SIDE_NAV_CLOSED_WIDTH;
}, function (_ref3) {
  var $isTouch = _ref3.$isTouch,
    $isOpen = _ref3.$isOpen;
  return $isTouch && "\n    height: ".concat($isOpen ? '100vh' : TOUCH_HEIGHT, ";\n    overflow: hidden;\n    position: absolute;\n    width: ").concat($isOpen ? '100%' : SIDE_NAV_CLOSED_WIDTH, ";\n\n    footer {\n      position: ").concat($isTouch && !$isOpen ? 'initial' : 'absolute', ";\n    }\n    ");
});
var Nav = styled.nav(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: ", ";\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-width: 100vw;\n  position: relative;\n  width: 100vw;\n\n  footer {\n    border-right: ", ";\n  }\n\n  ", "\n"])), function (_ref4) {
  var theme = _ref4.theme,
    $isDarkMode = _ref4.$isDarkMode,
    $isOpen = _ref4.$isOpen,
    $isTouch = _ref4.$isTouch;
  return $isDarkMode && $isTouch && !$isOpen ? theme.colours.canvas.tertiary.main : theme.colours.navigation.primary.main;
}, function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.sizing.xxtiny, " solid ").concat(theme.colours.canvas.primary.main);
}, function (_ref6) {
  var $isTouch = _ref6.$isTouch;
  return !$isTouch && "\n    position: static;\n    width: inherit;\n    &:hover {\n      width: ".concat(SIDE_NAV_OPENED_WIDTH, ";\n    }\n  ");
});

export { Aside, Nav };
//# sourceMappingURL=SideNavigation.styles.js.map
